module.exports = __webpack_public_path__ + "img/corneal-infiltrates-2.1ee35540.jpg";